// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VmR5EnRiQu6S2zEyriQJ{display:flex;flex-direction:column;justify-content:center;align-items:center;text-align:center}.pLduD6e0No2D_yBHZ9SE{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.rPaTnOJ8r_BuoWj47XTu{width:500px;padding-top:100px;padding-left:300px}.rPaTnOJ8r_BuoWj47XTu .HaugZp66ciP_pK2mcH0w{margin-top:20px;font-size:.9em;font-weight:600}`, "",{"version":3,"sources":["webpack://./assets/stylus/config/helpers.styl","webpack://./src/Pages/Me/Me.styl"],"names":[],"mappings":"AACA,sBACI,YAAS,CACT,qBAAgB,CAChB,sBAAiB,CACjB,kBAAa,CACb,iBAAY,CAEhB,sBACI,eAAS,CACT,kBAAY,CACZ,sBAAc,CCRlB,sBACI,WAAO,CACP,iBAAa,CACb,kBAAc,CACd,4CACI,eAAY,CACZ,cAAW,CAAO,eAAa","sourcesContent":["// centers the child\n.shaquille\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n\n.truncate\n    overflow hidden\n    white-space nowrap\n    text-overflow ellipsis","@import '~assets/stylus/config/colors'\n@import '~assets/stylus/config/helpers'\n\n.formWrapper\n    width: 500px;\n    padding-top: 100px;\n    padding-left: 300px;\n    .inputContainer\n        margin-top: 20px;\n        font-size: 0.9em; font-weight: 600;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"textColor": `#404041`,
	"colorRed": `#dd4e44`,
	"colorPink": `#ff1493`,
	"colorBlue": `#24b2e0`,
	"colorGreen": `#65c178`,
	"colorOrange": `#fa9961`,
	"colorYellow": `#e09f34`,
	"colorPurple": `#5841ab`,
	"colorDarkBlue": `#223c75`,
	"colorBrightBlue": `#3398d9`,
	"colorGoogle": `#4285f4`,
	"shaquille": `VmR5EnRiQu6S2zEyriQJ`,
	"truncate": `pLduD6e0No2D_yBHZ9SE`,
	"formWrapper": `rPaTnOJ8r_BuoWj47XTu`,
	"inputContainer": `HaugZp66ciP_pK2mcH0w`
};
export default ___CSS_LOADER_EXPORT___;
